//#region import libraries
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// custom components 
import { AssistanceSelector, BatterySelector } from "_molecules";

// bootstrap
import { Container, Row, Col, Form, Button, InputGroup, Popover, OverlayTrigger } from 'react-bootstrap';

// styles 
import { Colors } from '_styles';
import { HiOutlineInformationCircle } from "react-icons/hi";

// redux
import { useSelector, useDispatch } from 'react-redux';
import { resetPostedBooking, selectPatchBookingStatus, selectDeleteStatus } from '_redux/slices/prm-bookings/bookings';
import { selectBookingForm, setBookingForm, reset as resetForm } from '_redux/slices/assistance-bookings/booking-form';
import { selectEditBooking } from '_redux/slices/assistance-bookings/booking-requests-table'
import { setUser } from '_redux/slices/profile/user-profile';
//#endregion

const EditBooking = (props) => {


    const history = useHistory();

    // state variables 
    //#region
    const [firstName, setFirstName] = useState('');
    const [secondName, setSecondName] = useState('');
    const [submitted, setSubmitted] = useState(false);


    // local states
    const [flightStatus, setFlightStatus] = useState('idle');
    const [flightNumberError, setFlightNumberError] = useState('');
    const [flightNumberValid, setFlightNumberValid] = useState(false);
    const [carrierCodeValid, setCarrierCodeValid] = useState(false);

    // redux
    const dispatch = useDispatch();
    const bookingForm = useSelector(selectBookingForm);
    const patchStatus = useSelector(selectPatchBookingStatus)
    const deletedStatus = useSelector(selectDeleteStatus)
    const selectedBooking = useSelector(selectEditBooking)

    // errors
    const [errors, setErrors] = useState({});
    //#endregion   

    //#region  useEffect
    // inital reset on render
    useEffect(() => {
        dispatch(resetPostedBooking())
        dispatch(resetForm())
    }, []);

    // name split
    useEffect(() => {
        if (selectedBooking) {
            let name = selectedBooking.name.split(" ")

            setFirstName(name[0])
            setSecondName(name[name.length - 1])
            dispatch(setBookingForm({ ...selectedBooking }))
        }
    }, [selectedBooking]);

    // live error checkers       
    useEffect(() => {
        if (bookingForm && bookingForm.assistance) {
            if (bookingForm.assistance.length > 0) {
                const errors2 = { ...errors, assistance: "" }
                setErrors(errors2);
            }
        }
    }, [bookingForm.assistance]);

    useEffect(() => {
        if (bookingForm && bookingForm.referenceNumber) {
            if (bookingForm.referenceNumber.length > 0 && bookingForm.referenceNumber.length < 5) {
                const errors2 = { ...errors, referenceNumber: "" }
                setErrors(errors2);
            }
        }
    }, [bookingForm.referenceNumber]);

    useEffect(() => {
        if (bookingForm && bookingForm.dueTime) {
            if (bookingForm.dueTime && bookingForm.dueTime.length > 0) {
                const errors2 = { ...errors, dueTime: "" }
                setErrors(errors2);
            }
        }
    }, [bookingForm.dueTime]);

    // monitor patch status
    useEffect(() => {
        if (patchStatus == 'succeeded' && submitted) {
            // show success modal
            setConfirmedBookingModal(true)
            dispatch(resetForm())
        }
    }, [patchStatus]);

    // monitor delete status
    useEffect(() => {
        if (deletedStatus == 'succeeded') {
            // show success modal
            dispatch(resetForm())
        }
    }, [deletedStatus]);
    //#endregion

    const showProfile = () => {
        // set user
        if (selectedBooking.userId) {
            dispatch(setUser(selectedBooking.userId))
            history.push('/user-profile')
        }
    }

    const popover = (
        <Popover id="popover-basic">
            <Popover.Header style={{ backgroundColor: Colors.PRM_LIGHT_BLUE, color: 'white' }} as="h3">PRM Portal</Popover.Header>
            <Popover.Body>
                Passenger due time is the time that the passenger expects they will arrive at the airport. This information helps airport administrators plan for passengers arrival.
            </Popover.Body>
        </Popover>
    );

    return (
        <Row style={{ marginBottom: 50 }}>
            <Col>
                <Row>
                    <Form>

                        {/* Name & Assistance */}
                        <Form.Group className="mt-3">
                            <Row>
                                <Col>
                                    <Row>
                                        <Form.Label style={{ color: '' }}>Passenger First Name</Form.Label>
                                        <Container>
                                            <Form.Control disabled={true} type="name" placeholder="Enter first" style={{}} value={firstName} defaultValue={firstName} />
                                        </Container>
                                    </Row>
                                    <Row className="mt-3">
                                        <Form.Label style={{ color: '' }}>Passenger Last Name</Form.Label>
                                        <Container>
                                            <Form.Control disabled={true} style={{}} type="name" placeholder="Enter second" defaultValue={secondName} value={secondName} />
                                        </Container>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row>
                                        <Form.Label style={{}}>Passenger Assistance Requirements</Form.Label>
                                        <AssistanceSelector setAssistance={(val) => { dispatch(setBookingForm({ ...bookingForm, assistance: val })) }} defaultValue={bookingForm.assistance} value={bookingForm.assistance} />
                                        {errors.assistance && (<p style={{ color: Colors.TEXT_COLOR }} className="text-danger">{errors.assistance}</p>)}
                                    </Row>
                                    <Row className="mt-3">
                                        <Form.Label style={{ color: '' }}>Notes (Optional)</Form.Label>
                                        <Container>
                                            <Form.Control as='textarea' style={{ borderColor: '' }} onChange={(e) => { dispatch(setBookingForm({ ...bookingForm, bio: e.target.value })) }} type="prmbio" placeholder="Any additional notes on the booking" defaultValue={bookingForm.bio} />
                                            {errors.prmBio && (<p style={{ color: Colors.TEXT_COLOR }} className="text-danger">{errors.prmBio}</p>)}
                                        </Container>
                                    </Row>
                                </Col>
                            </Row>
                        </Form.Group>

                        {/* Carrier Code, Flight Number & Reference Code */}
                        <Form.Group className="mt-5">
                            <Row>
                                <Col>
                                    <Row>
                                        <Col xs={6}>
                                            <Form.Label style={{ color: '' }}>Carrier Code</Form.Label>
                                        </Col>
                                        <Col>
                                            <Form.Label style={{ color: '' }}>Flight Number</Form.Label>
                                        </Col>
                                    </Row>
                                    <InputGroup>
                                        <Form.Control disabled={true} onChange={(e) => { dispatch(setBookingForm({ ...bookingForm, carrierCode: e.target.value })) }} type="name" style={{ textTransform: 'uppercase', borderColor: carrierCodeValid ? '' : flightStatus == 'failed' ? 'red' : null }} value={bookingForm && bookingForm.flightConfirmationDetails && bookingForm.flightConfirmationDetails.carrierCode ? bookingForm.flightConfirmationDetails.carrierCode : ""} defaultValue={bookingForm && bookingForm.flightConfirmationDetails && bookingForm.flightConfirmationDetails.carrierCode ? bookingForm.flightConfirmationDetails.carrierCode : ""} />
                                        <Form.Control disabled={true} onChange={(e) => { dispatch(setBookingForm({ ...bookingForm, flightNumber: e.target.value })) }} type="name" style={{ textTransform: 'uppercase', borderColor: flightNumberValid ? '' : flightNumberError.length > 0 || flightStatus == 'failed' ? 'red' : null }} value={bookingForm && bookingForm.flightConfirmationDetails && bookingForm.flightConfirmationDetails.flightNumber ? bookingForm.flightConfirmationDetails.flightNumber : ""} defaultValue={bookingForm && bookingForm.flightConfirmationDetails && bookingForm.flightConfirmationDetails.flightNumber ? bookingForm.flightConfirmationDetails.flightNumber : ""} />
                                    </InputGroup>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        {
                                            errors.flightNumber ?
                                                (
                                                    <p style={{ color: Colors.TEXT_COLOR }} className="text-danger">{errors.flightNumber}</p>
                                                )
                                                :
                                                flightNumberError ?
                                                    (
                                                        <p style={{ color: Colors.TEXT_COLOR }} className="text-danger">{flightNumberError}</p>
                                                    )
                                                    :
                                                    ""
                                        }
                                    </div>
                                </Col>

                                {bookingForm && bookingForm.referenceNumber &&
                                    <Col>
                                        <Form.Label style={{ color: bookingForm && bookingForm.referenceNumber && bookingForm.referenceNumber.length == 0 ? Colors.PRM_LIGHT_BLUE : bookingForm.referenceNumber.length > 0 && bookingForm.referenceNumber.length < 4 ? 'red' : '' }}>Airline Booking Reference Number (Optional)</Form.Label>
                                        <Form.Control onChange={(e) => { dispatch(setBookingForm({ ...bookingForm, referenceNumber: e.target.value })) }} type="name" style={{ textTransform: 'uppercase', borderColor: bookingForm.referenceNumber.length == 0 ? null : bookingForm.referenceNumber.length > 0 && bookingForm.referenceNumber.length < 4 ? 'red' : '' }} value={bookingForm.referenceNumber} defaultValue={bookingForm.referenceNumber} />
                                        {errors.referenceNumber && (<p style={{ color: Colors.TEXT_COLOR }} className="text-danger">{errors.referenceNumber}</p>)}
                                    </Col>
                                }
                            </Row>
                        </Form.Group>

                        {/* Flight Date & Due Time */}
                        <Form.Group className="mt-3">
                            <Row>
                                {bookingForm && bookingForm.flightDetails &&
                                    <Col>
                                        <Form.Label style={{ color: bookingForm && bookingForm.flightDetails && bookingForm.flightDetails.departureDate && bookingForm.flightDetails.departureDate.length != 0 ? '' : Colors.PRM_LIGHT_BLUE }}>Flight Departure Date</Form.Label>
                                        <Form.Control disabled={true} onChange={(e) => { dispatch(setBookingForm({ ...bookingForm, flightDepartureDate: e.target.value })) }} style={{ borderColor: bookingForm && bookingForm.flightDetails && bookingForm.flightDetails.departureDate && bookingForm.flightDetails.departureDate.length != 0 ? '' : null }} type="date" value={bookingForm && bookingForm.flightDetails && bookingForm.flightDetails.departureDate ? bookingForm.flightDetails.departureDate : ""} defaultValue={bookingForm && bookingForm.flightDetails && bookingForm.flightDetails.departureDate ? bookingForm.flightDetails.departureDate : ""} />
                                        {errors.departureDate && (<p style={{ color: Colors.TEXT_COLOR }} className="text-danger">{errors.departureDate}</p>)}
                                    </Col>
                                }
                                <Col>
                                    <OverlayTrigger trigger="hover" placement="left" overlay={popover}>
                                        <div style={{ cursor: 'pointer', justifyContent: 'space-between', display: 'flex' }}>
                                            <Form.Label style={{ color: '' }}>Due Time (Optional)</Form.Label>
                                            <HiOutlineInformationCircle size={20} style={{}} color={''} value={{ color: Colors.PRM_LIGHT_BLUE }} />
                                        </div>
                                    </OverlayTrigger>
                                    <Form.Control onChange={(e) => { dispatch(setBookingForm({ ...bookingForm, dueTime: e.target.value })) }} style={{}} type="time" value={bookingForm.dueTime} defaultValue={bookingForm.dueTime} />
                                    {errors.dueTime && (<p style={{ color: Colors.TEXT_COLOR }} className="text-danger">{errors.dueTime}</p>)}
                                </Col>
                            </Row>
                        </Form.Group>

                        {
                            bookingForm.equipment ?
                                <Form.Group>
                                    <Row>
                                        {
                                            bookingForm.equipmentInformation.make != null ?
                                                <Col>
                                                    <Form.Label style={{ color: errors.hasOwnProperty('make') && bookingForm.equipmentInformation != null && bookingForm.equipmentInformation.make != null && bookingForm.equipmentInformation.make.length == 0 ? 'red' : bookingForm.equipmentInformation.make.length == 0 ? Colors.PRM_LIGHT_BLUE : '' }}>Make</Form.Label>
                                                    <Form.Control onChange={(e) => { dispatch(setBookingForm({ ...bookingForm, equipmentInformation: { ...bookingForm.equipmentInformation, make: e.target.value } })) }} type="name" placeholder="Enter equipment make" style={{ borderColor: bookingForm.equipmentInformation.make.length == 0 ? null : '' }} value={bookingForm.equipmentInformation.make} defaultValue={bookingForm.equipmentInformation.make} />
                                                    {errors.make && (<p style={{ color: Colors.TEXT_COLOR }} className="text-danger">{errors.make}</p>)}
                                                </Col>
                                                : ''
                                        }
                                        {
                                            bookingForm.equipmentInformation.model != null ?
                                                <Col>
                                                    <Form.Label style={{ color: errors.hasOwnProperty('model') && bookingForm.equipmentInformation.model.length == 0 ? 'red' : bookingForm.equipmentInformation.model.length == 0 ? Colors.PRM_LIGHT_BLUE : '' }}>Model</Form.Label>
                                                    <Form.Control onChange={(e) => { dispatch(setBookingForm({ ...bookingForm, equipmentInformation: { ...bookingForm.equipmentInformation, model: e.target.value } })) }} type="name" placeholder="Enter equipment model" style={{ borderColor: bookingForm.equipmentInformation.model.length == 0 ? null : '' }} value={bookingForm.equipmentInformation.model} defaultValue={bookingForm.equipmentInformation.model} />
                                                    {errors.model && (<p style={{ color: Colors.TEXT_COLOR }} className="text-danger">{errors.model}</p>)}
                                                </Col>
                                                : ''}
                                    </Row>
                                    <Row className="mt-3">
                                        {
                                            bookingForm.equipmentInformation.dimensions != null && bookingForm.equipmentInformation.dimensions.height != null ?
                                                <Col>
                                                    <Form.Label style={{ color: errors.hasOwnProperty('height') && bookingForm.equipmentInformation.dimensions.height.length == 0 ? 'red' : bookingForm.equipmentInformation.dimensions.height.length == 0 ? Colors.PRM_LIGHT_BLUE : '' }}>Height (Collapsed)</Form.Label>
                                                    <Form.Control onChange={(e) => { dispatch(setBookingForm({ ...bookingForm, equipmentInformation: { ...bookingForm.equipmentInformation, dimensions: { ...bookingForm.equipmentInformation.dimensions, height: e.target.value } } })) }} type="name" placeholder="Enter equipment height" style={{ borderColor: bookingForm.equipmentInformation.dimensions.height.length == 0 ? null : '' }} value={bookingForm.equipmentInformation.dimensions.height} defaultValue={bookingForm.equipmentInformation.dimensions.height} />
                                                    {errors.height && (<p style={{ color: Colors.TEXT_COLOR }} className="text-danger">{errors.height}</p>)}
                                                </Col>
                                                : ''
                                        }
                                        {
                                            bookingForm.equipmentInformation.dimensions != null && bookingForm.equipmentInformation.dimensions.width != null ?
                                                <Col>
                                                    <Form.Label style={{ color: errors.hasOwnProperty('width') && bookingForm.equipmentInformation.dimensions.width.length == 0 ? 'red' : bookingForm.equipmentInformation.dimensions.width.length == 0 ? Colors.PRM_LIGHT_BLUE : '' }}>Width (Collapsed)</Form.Label>
                                                    <Form.Control onChange={(e) => { dispatch(setBookingForm({ ...bookingForm, equipmentInformation: { ...bookingForm.equipmentInformation, dimensions: { ...bookingForm.equipmentInformation.dimensions, width: e.target.value } } })) }} type="name" placeholder="Enter equipment width" style={{ borderColor: bookingForm.equipmentInformation.dimensions.width.length == 0 ? null : '' }} value={bookingForm.equipmentInformation.dimensions.width} defaultValue={bookingForm.equipmentInformation.dimensions.width} />
                                                    {errors.width && (<p style={{ color: Colors.TEXT_COLOR }} className="text-danger">{errors.width}</p>)}
                                                </Col>
                                                : ''
                                        }
                                    </Row>
                                    <Row>
                                        {
                                            bookingForm.equipmentInformation != null && bookingForm.equipmentInformation.weight != null ?
                                                <Col>
                                                    <Row className="mt-3">
                                                        <Form.Label style={{ color: errors.hasOwnProperty('weight') ? 'red' : !bookingForm.equipmentInformation.weight ? Colors.PRM_LIGHT_BLUE : '' }}>Weight (kg)</Form.Label>
                                                        <Container>
                                                            <Form.Control onChange={(e) => { dispatch(setBookingForm({ ...bookingForm, equipmentInformation: { ...bookingForm.equipmentInformation, weight: e.target.value } })) }} type="name" placeholder="Enter equipment weight" style={{ borderColor: bookingForm && bookingForm.equipmentInformation.weight == {} ? null : '' }} value={bookingForm.equipmentInformation.weight != null ? bookingForm.equipmentInformation.weight : ""} defaultValue={bookingForm.equipmentInformation.weight ? bookingForm.equipmentInformation.weight : ""} />
                                                            {errors.weight && (<p style={{ color: Colors.TEXT_COLOR }} className="text-danger">{errors.weight}</p>)}
                                                        </Container>
                                                    </Row>
                                                </Col>
                                                : ''
                                        }
                                        {
                                            bookingForm.equipmentInformation != null && bookingForm.equipmentInformation.battery != null ?
                                                <Col>
                                                    <Row className="mt-3">
                                                        <Form.Label style={{ color: errors.hasOwnProperty('battery') && bookingForm.equipmentInformation.battery && bookingForm.equipmentInformation.battery.length == 0 ? 'red' : bookingForm.equipmentInformation.battery && bookingForm.equipmentInformation.battery.length == 0 ? Colors.PRM_LIGHT_BLUE : '' }}>Battery</Form.Label>
                                                        <Container>
                                                            <BatterySelector setList={(list) => { dispatch(setBookingForm({ ...bookingForm, battery: list })) }} defaultValue={bookingForm.battery} value={bookingForm.battery} />
                                                            {errors.battery && (<p style={{ color: Colors.TEXT_COLOR }} className="text-danger">{errors.battery}</p>)}
                                                        </Container>
                                                    </Row>
                                                </Col>
                                                : ''
                                        }
                                    </Row>
                                </Form.Group>
                                : null }
                    </Form>
                </Row>
            </Col>

            <Row className='mt-4' style={{ alignItems: 'flex-end' }}>
                <Button variant={"outline-primary"} onClick={showProfile} loading={true} style={{ width: 150, marginLeft: 15 }}>{'View Profile'}</Button>
            </Row>
        </Row>
    );
};

export default EditBooking;